import { _axios } from "../../../Utils/Axios/axios";

export const getRequestedFilesService = async (userToken: string) => {
  return _axios.get("/pdf-requests", {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
